/** Minimum fraction digits (never below `MIN_DP`) that print every value in
 * `values` without dropping a significant digit.
 *
 * Trailing zeros are noise on a statement, but trimming per cell would break
 * the decimal alignment of a right-aligned column - measure per column so all
 * its rows share one fraction width. This drops zeros, it does NOT round.
 * String work only, no Number() - HON-03. Shared by StatementDocumentView's
 * ledger columns and the expanded row's Rate column, so the two never disagree
 * on how many digits a rate keeps.
 */
export const MIN_DP = 2;

export const columnDp = (
  values: (string | null | undefined)[],
  maxDp: number,
): number => {
  let needed = MIN_DP;
  for (const value of values) {
    if (!value) continue;
    const fraction = value.split('.')[1] ?? '';
    const significant = fraction.slice(0, maxDp).replace(/0+$/, '').length;
    // A nonzero value whose digits all sit below MIN_DP measures 0 significant
    // digits and would print a real accrual as '0.00' - show the full width
    // instead of a zero for a nonzero figure in a money column.
    if (significant === 0 && /[1-9]/.test(fraction)) return maxDp;
    if (significant > needed) needed = significant;
    if (needed >= maxDp) return maxDp;
  }
  return needed;
};
